import React from 'react';
import type { FC } from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    height: '50px',
    marginTop: '2px'
  }
}));

const Logo: FC = () => {
  const styles = useStyles();

  return (
    <img
      className={styles.root}
      alt="НО РАО"
      src="/static/no_rao_logo.png"
    />
  );
};

export default Logo;
